import * as types from './auth.actionTypes';

export const loginUserRequestActionCreator = () => {
  return { type: types.LOGIN_USER_REQUEST };
};

export const loginUserSuccessActionCreator = user => {
  return { type: types.LOGIN_USER_SUCCESS, user };
};
export const getTermsRequestActionCreator = () => {
  return { type: types.GET_CURRENT_TERMS_REQUEST };
};

export const getPrivacyRequestActionCreator = () => {
  return { type: types.GET_CURRENT_PRIVACY_REQUEST };
};

export const loginUserFailureActionCreator = () => {
  return { type: types.LOGIN_USER_FAILURE };
};

export const logoutUserActionCreator = () => {
  return { type: types.LOGOUT_USER };
};

export const getCurrentUserRequestActionCreator = () => {
  return { type: types.GET_CURRENT_USER_REQUEST };
};

export const getCurrentUserSuccessActionCreator = user => {
  return { type: types.GET_CURRENT_USER_SUCCESS, user };
};

export const getCurrentUserFailureActionCreator = () => {
  return { type: types.GET_CURRENT_USER_FAILURE };
};

export const setChatTokenActionCreator = token => {
  return { type: types.SET_CHAT_TOKEN, token };
};
export const updateUserProfileRequestActionCreator = () => {
  return { type: types.UPDATE_USER_PROFILE_REQUEST };
};

export const updateUserProfileSuccessActionCreator = user => {
  return { type: types.UPDATE_USER_PROFILE_SUCCESS, user };
};

export const updateUserProfileFailureActionCreator = () => {
  return { type: types.UPDATE_USER_PROFILE_FAILURE };
};

// export const addBankAccountSuccessActionCreator = data => {
//   return { type: types.ADD_BANK_ACCOUNT_SUCCESS, data };
// };
// export const deleteBankAccountSuccessActionCreator = id => {
//   return { type: types.DELETE_BANK_ACCOUNT_SUCCESS, id };
// };
export const fetchBankAccountSuccessActionCreator = data => {
  return { type: types.FETCH_BANK_ACCOUNT_SUCCESS, data };
};

export const addCreditCardSuccessActionCreator = data => {
  return { type: types.ADD_CREDIT_CARD_SUCCESS, data };
};
export const deleteCreditCardSuccessActionCreator = id => {
  return { type: types.DELETE_CREDIT_CARD_SUCCESS, id };
};
export const changeDefaultCreditCardSuccessActionCreator = id => {
  return { type: types.DEFAULT_CREDIT_CARD_CHANGE_SUCCESS, id };
};
export const fetchCreditCardRequestActionCreator = data => {
  return { type: types.FETCH_CREDIT_CARDS_REQUEST, data };
};



export const fetchCountryListdRequestActionCreator = data => {
  return { type: types.FETCH_COUNTRY_LIST_REQUEST, data };
};
export const fetchCountryListSuccessActionCreator = data => {
  return { type: types.FETCH_COUNTRY_LIST_SUCCESS, data };
};



export const fetchStateListdRequestActionCreator = data => {
  return { type: types.FETCH_STATE_LIST_REQUEST, data };
};
export const fetchStateListSuccessActionCreator = data => {
  return { type: types.FETCH_STATE_LIST_SUCCESS, data };
};



export const fetchCreditCardSuccessActionCreator = data => {
  return { type: types.FETCH_COUNTRY_LIST_SUCCESS, data };
};
export const fetchCreditCardFailureActionCreator = data => {
  return { type: types.FETCH_CREDIT_CARDS_FAILURE, data };
};
export const toggleSubscribeUserSuccessActionCreator = subscribed => {
  return { type: types.TOGGLE_SUBSCRIBE_USER_SUCCESS, subscribed };
};
export const fetchNotificationCountSuccessActionCreator = count => {
  return { type: types.FETCH_NOTIFICATION_COUNT, count };
};
export const addBankAccountSuccessActionCreator = data => {
  return { type: types.ADD_BANK_ACCOUNT_SUCCESS, data };
};
